module.exports = __webpack_public_path__ + "img/telegram.82809dc0.svg";